.chip {
	text-transform: uppercase;
	letter-spacing: 0.025em;
	display: inline-flex;
	align-items: center;
	gap: var(--size-3);
	font-size: var(--text-caption);
	padding: 2px calc(var(--size-3) + 2px);
	border-radius: var(--size-10);
	font-weight: bold;
	color: var(--color-text-subtle);
	background-color: var(--color-surface);

	&.status {
		border: var(--size-border-lg) solid light-dark(var(--color-background), var(--gray-700));
		&[data-online="true"] {
			border: var(--size-border-lg) solid var(--color-success-background);
			color: var(--color-success-foreground);

			&::before {
				border: var(--size-border-lg) solid var(--color-success-foreground);
			}
		}
		&::before {
			content: "";
			display: block;
			width: var(--size-3);
			height: var(--size-3);
			background-color: currentColor;
			border-radius: 100%;
			corner-shape: round;
		}
	}

	&.maintenance {
		padding: var(--size-2) calc(var(--size-3) + 2px);
		border: var(--size-border-lg) solid var(--color-warning-background);
		color: var(--color-warning-foreground);
		background-color: var(--color-warning-background);
	}
}

.connections {
	display: flex;
	flex-direction: column;
	gap: var(--size-1);
	margin: 0;
	padding: 0;
	list-style: none;
	text-align: left;

	.connection {
		display: flex;
		align-items: center;
		gap: var(--size-2);
	}
}
